import LogsDownloadsRPIs from "./LogsDownloadsRPIs";

export default LogsDownloadsRPIs;